var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-time-picker',{attrs:{"use-seconds":"","color":"primary"},model:{value:(_vm.picker),callback:function ($$v) {_vm.picker=$$v},expression:"picker"}})}
var staticRenderFns = []

export { render, staticRenderFns }